<form [formGroup]="form" (ngSubmit)="save()" class="p-6 w-full">
  <h2 class="text-lg font-semibold text-slate-900">
    {{ (isEdit ? 'tariff.form.editTitle' : 'tariff.form.newTitle') | translate }}
  </h2>
  <p class="mt-1 text-sm text-slate-500">{{ 'tariff.form.hint' | translate }}</p>

  <div class="mt-5 space-y-4">
    <div>
      <label class="block text-sm font-medium text-slate-700 mb-1" for="tf-name">{{ 'tariff.form.name' | translate }}</label>
      <input
        id="tf-name"
        type="text"
        formControlName="name"
        [placeholder]="'tariff.form.namePlaceholder' | translate"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 focus:outline-none" />
      @if (form.controls.name.touched && form.controls.name.invalid) {
        <p class="mt-1 text-xs text-red-600">{{ 'tariff.form.nameError' | translate }}</p>
      }
    </div>

    <div>
      <label class="block text-sm font-medium text-slate-700 mb-1" for="tf-desc">{{ 'tariff.form.description' | translate }} <span class="text-slate-400 font-normal">{{ 'tariff.form.optional' | translate }}</span></label>
      <textarea
        id="tf-desc"
        rows="2"
        formControlName="description"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 placeholder:text-slate-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 focus:outline-none"></textarea>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <div>
        <label class="block text-sm font-medium text-slate-700 mb-1" for="tf-currency">{{ 'tariff.form.currency' | translate }}</label>
        <input
          id="tf-currency"
          type="text"
          maxlength="3"
          formControlName="currency"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm uppercase text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 focus:outline-none" />
        @if (form.controls.currency.touched && form.controls.currency.invalid) {
          <p class="mt-1 text-xs text-red-600">{{ 'tariff.form.currencyError' | translate }}</p>
        }
      </div>
      <div>
        <label class="block text-sm font-medium text-slate-700 mb-1" for="tf-priority">{{ 'tariff.form.priority' | translate }}</label>
        <input
          id="tf-priority"
          type="number"
          min="0"
          formControlName="priority"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 focus:outline-none" />
        <p class="mt-1 text-xs text-slate-400">{{ 'tariff.form.priorityHint' | translate }}</p>
      </div>
    </div>
  </div>

  <div class="mt-6 flex justify-end gap-2">
    <button
      type="button"
      (click)="cancel()"
      class="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors">
      {{ 'tariff.form.cancel' | translate }}
    </button>
    <button
      type="submit"
      class="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 transition-colors">
      {{ (isEdit ? 'tariff.form.save' : 'tariff.form.create') | translate }}
    </button>
  </div>
</form>
